import { gql } from "../../__generated__";
export const SELECTED_STUDENT_QUERY = gql(/* GraphQL */` 
    query SelectedStudent($id: UUID!) {
        student(id: $id) {
            ... SelectedStudent_Student
        }
    }
`);

export const SELECTED_STUDENT_FRAGMENT = gql(/* GraphQL */`
  fragment SelectedStudent_Student on Student {
    __typename
    id 
    locationId
    location{
        name
    }
    firstName
    middleName
    lastName
    dob
    postalCode
    parentEmail
    parentPhone
    email
    startDate
    endDate
    expired
    references
    parentalConsentStatus
    lastConsentAction{
        id
        type
        createdAt
    }
    consentEmailSentTimes
    persons {
    edges{
    cursor
    node{
    id}}
    
        }
    studentCustomFields {
        __typename
        value
        customField {
            __typename
            id
        }
    }
  } 
`);
